class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

 connectedCallback() {
  this.header = document.querySelector('sticky-header');
  this.drawer = document.querySelector('cart-drawer');
  new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  
  // Re-fetch mini-cart after Magical Fees adds the fee asynchronously
  document.addEventListener('cartdrawer:opened', this.refreshAfterFee.bind(this));
}

refreshAfterFee() {
  setTimeout(() => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const items = cart.items;
        const onlyFee = items.length > 0 && items.every(item => item.handle === 'luxury-handling-1');
        
        if (onlyFee) {
          const feeItem = items.find(item => item.handle === 'luxury-handling-1');
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: feeItem.key, quantity: 0 })
          }).then(() => {
            fetch(this.dataset.url)
              .then(response => response.text())
              .then(html => {
                const miniCart = document.getElementById('mini-cart');
                if (miniCart) {
                  miniCart.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
                }
              });
          });
        }

        // Comportamiento original — refrescar el mini-cart normalmente
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(html => {
            const miniCart = document.getElementById('mini-cart');
            if (miniCart) {
              miniCart.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
            }
          })
          .catch(e => console.error(e));
      });
  }, 800);
}



  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
